import { useState } from 'react';
import { Link } from 'react-scroll'
import './style.css';



const MobileMenuSec = () => {
    const [menuActive, setMenuState] = useState(false);

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    <li><Link activeClass="active" to="demo" spy={true} smooth={true} offset={-100} duration={500} >Demo</Link></li>
                    <li><Link activeClass="active" to="features" spy={true} smooth={true} offset={-100} duration={500} >Features</Link></li>
                    <li><a target='_blank' rel="noreferrer" href="https://wpolive.com/docs/bohu/index.html">Documentation</a></li>
                </ul>

            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenuSec;